import { Helmet } from "react-helmet";
import BreadCrumbAuction from "../../components/auction/BreadCrumbAuction";
import Content from "../../components/auction/Content";
import Footer from "../../components/shared/Footer";
import Navbar from "../../components/shared/Navbar";
import RightBar from "../../components/shared/RightBar";

export default function Auction() {
    return (
        <div className="flex flex-col min-h-screen">
            <Helmet>
                <title>Lelang - BPR Palu Anugerah</title>
                <meta name="description" content="Temukan informasi lelang properti dan aset dari BPR Palu Anugerah. Dapatkan peluang investasi melalui lelang yang transparan dan terpercaya." />
                <meta name="robots" content="index, follow" />
                <meta property="og:title" content="Lelang - BPR Palu Anugerah" />
                <meta property="og:description" content="Temukan informasi lelang properti dan aset dari BPR Palu Anugerah. Dapatkan peluang investasi melalui lelang yang transparan dan terpercaya." />
                <meta property="og:type" content="website" />
            </Helmet>
            <Navbar />
            <RightBar></RightBar>
            <main className="flex-grow">
                <BreadCrumbAuction></BreadCrumbAuction>
                <Content></Content>
            </main>
            <Footer />
        </div>
    )
}